module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/blog-post-d7b5428ac1ac5b48f9cc8457d74221f9.jpg";